import axios from './_nestAxios'

export const getAlmacen = _id => axios.get(`/almacenes/${_id}`)
export const getAlmacenes_Select = () => axios.get('/almacenes', { params: { tipoConsulta: 'select' } })
export const nuevoAlmacen = data => axios.post('/almacenes', data)
export const actualizarAlmacen = (_id, data) => axios.put(`/almacenes/${_id}`, data)
export const eliminarAlmacen = _id => axios.delete(`/almacenes/${_id}`)
